import { Grid2 } from '@aibees/shared/components';
import { styled } from '@mui/material';

export const Wrapper = styled(Grid2)`
  max-width: ${(p) => p.theme.spacing(135)};
  background: ${(p) => p.theme.palette.common.white};
  border-radius: ${(p) => p.theme.spacing(1.5)};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${(p) => p.theme.spacing(2)};
  padding: ${(p) => p.theme.spacing(2)};
`;

export const Content = styled(Grid2)`
  padding: ${(p) => p.theme.spacing(1)};
  .MuiButtonBase-root {
    margin-right: ${(p) => p.theme.spacing(2.5)} !important;
    &.Mui-selected {
      color: ${(p) => p.theme.palette.common.black};
    }
    &:not(.Mui-selected) {
      color: ${(p) => p.theme.palette.common.black};
    }
  }
`;

export const LeftSide = styled(Grid2)`
  margin-top: ${(p) => p.theme.spacing(2)};
`;
